import { useDispatch, useSelector } from 'react-redux';
import {
  fetchPostJobRun,
  fetchGetJobRun,
  fetchPostJobAbort,
  fetchPostJobAbortAll,
  fetchGetContentList,
  fetchGetJobStatus,
  fetchUpdateJobTemplate,
  fetchUpdateJobWorkflow,
  cleanUpJob,
  cleanUpMessageJob,
  fetchGetNextPage
} from 'state-managament/job.slice';

export default function useJob(project) {
  const { error, success, isLoaded, data, contentList, contentListStatusMap } = useSelector((state) => state.job);
  const dispatch = useDispatch();

  const cleanUp = () => dispatch(cleanUpJob());
  const cleanUpMessage = () => dispatch(cleanUpMessageJob());
  const getJobRun = (args) => dispatch(fetchGetJobRun(args));
  const getNextPage = (args) => dispatch(fetchGetNextPage({...args,currentTail: data.tail, page:(data.page || 0)+1, dontLoadMore:data.dontLoadMore}));
  const postJobRun = (args) => dispatch(fetchPostJobRun(args));
  const postJobAbort = (args) => dispatch(fetchPostJobAbort(args));
  const postJobAbortAll = (args) => dispatch(fetchPostJobAbortAll(args));
  const getContentList = (args) => dispatch(fetchGetContentList(args));
  const getJobStatus = (args) => dispatch(fetchGetJobStatus(args));
  const updateJobTemplate = (args) => dispatch(fetchUpdateJobTemplate(args));
  const updateJobWorkflow = (args) => dispatch(fetchUpdateJobWorkflow(args));

  

  return {
    error,
    success,
    isLoaded,
    contentList,
    contentListStatusMap,
    data,
    cleanUp,
    cleanUpMessage,
    getJobRun,
    getNextPage,
    postJobRun,
    postJobAbort,
    postJobAbortAll,
    getContentList,
    getJobStatus,
    updateJobTemplate,
    updateJobWorkflow
  };

}
